<template>
    <div class="flex items-center justify-center w-full">
        <div class="flex flex-col gap-4 w-full max-w-[500px]">
            <h1 class="text-2xl font-bold">Login</h1>
            <FormKit type="form" @submit="submit" :actions="false">
                <FormKit
                    type="email"
                    name="username"
                    label="Username"
                    v-model="form.username"
                />
                <FormKit
                    type="password"
                    name="password"
                    label="Password"
                    v-model="form.password"
                />
                <div class="flex items-center gap-4 w-full">
                    <FormKit type="submit" label="Login" />
                    <a href="/forgot-password" class="text-sm text-blue-500 hover:underline">
                        Forgot Password
                    </a>
                </div>
            </FormKit>
        </div>
    </div>
</template>

<script setup>
import { ref } from "vue";
import { usePage, router } from "@inertiajs/vue3";
import { FormKit } from "@formkit/vue";

const form = ref({
    username: "",
    password: "",
    _csrfToken: usePage().props._csrfToken,
});

const submit = () => {
    router.post("/login", form.value, {
        headers: {
            "X-CSRF-Token": usePage().props._csrfToken,
        },
    });
};
</script>
